import { moveToFulfilled } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { SearchLoadFulfilledAction, SearchLoadMoreFulfilledAction } from '../../domains/searches/actions.types';

import type { SearchResultThreads } from './types';

export type SearchResultThreadAction = SearchLoadFulfilledAction | SearchLoadMoreFulfilledAction;

const initialState: SearchResultThreads = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<SearchResultThreads, SearchResultThreadAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'SEARCH.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.searchResultThreads);
    case 'SEARCH.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.searchResultThreads);
    default:
      return state;
  }
};

export default reducer;
